<template>
    <div class="container">
        <div class="get-result">
            <figure>
                <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="70" height="70" rx="35" fill="#54DBA3"/>
                <path d="M28.1823 44.408L52.2448 20.3455C52.6904 19.8999 53.2251 19.6771 53.849 19.6771C54.4728 19.6771 55.0298 19.8999 55.52 20.3455C55.9656 20.7911 56.1884 21.3481 56.1884 22.0165C56.1884 22.6403 55.9656 23.1751 55.52 23.6207L29.7865 49.3542C29.3409 49.7998 28.8061 50.0226 28.1823 50.0226C27.5584 50.0226 27.0237 49.7998 26.5781 49.3542L14.4132 37.1892C13.9676 36.7436 13.7448 36.2089 13.7448 35.5851C13.7894 34.9167 14.0344 34.3597 14.48 33.9141C14.9256 33.4685 15.4604 33.2457 16.0842 33.2457C16.7526 33.2457 17.3096 33.4685 17.7552 33.9141L28.1823 44.408Z" fill="white"/>
                </svg>
            </figure>

            <h1 class="new-headline-md text-centered">Ihr Ergebnis wartet auf Sie</h1>

            <p class="new-text-lg text-color-default text-centered">Danke, dass Sie sich die Zeit genommen haben. Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Ergebnis zu erhalten.</p>

            <form id="quiz-form" role="form" method="POST" action="#" @submit.prevent="submit" novalidate>
                <form-input-type-email
                    name="email"
                    label="E-Mail-Adresse"
                    :errors="errors.email"
                    full-border
                    required
                ></form-input-type-email>

                <form-input-type-checkbox
                    name="agreements"
                    label='Durch Eingabe Ihres Namens und Ihrer E-Mail-Adresse erklären Sie sich mit den Bestimmungen zum <a href="/datenschutzerklarung" target="_blank">Datenschutz</a> einverstanden.'
                    :errors="errors.agreements"
                    required
                ></form-input-type-checkbox>

                <v-button label="Ergebnis anzeigen" type="submit" position="center" size="lg"></v-button>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            totalScore: {
                type: Number,
                required: true
            },
            answers: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                errors: {}
            }
        },
        created() {
            window.scrollTo(0, 0)
            window.dataLayer.push({
                event: 'diabetes_test_completed',
                conversion: 'Diabetes Test Completed'
            })
        },

        methods: {
            submit() {
                let formData = {}

                // serialize form data
                $('#quiz-form')
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })

                formData['score'] = this.totalScore
                formData['answers'] = JSON.stringify(this.answers)

                axios
                    .post('api/patient-quiz-form', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        window.dataLayer.push({
                            event: 'diabetes_test_email',
                            conversion: 'Diabetes Test Email Received'
                        })
                        window.location.replace('result-page?score=' + this.totalScore)
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
        }
    }
</script>
